import { makeStyles } from '@mui/styles'
import colors from '../../utils/colors'
const useStyles = makeStyles({
  marker: {
    backgroundColor: colors.secondary,
    color: 'white',
    padding: '5px',
    display: 'inline-flex',
    textAlign: 'left',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(-50%, -50%)',
  },
  // the pin points at the coordinate with its tip, not with its centre
  pin: {
    lineHeight: 0,
    transform: 'translate(-50%, -100%)',
    filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, 0.35))',
  },
})

export default useStyles
